interface OpenToWorkStatusProps {
  isOpenToWork: boolean;
}

const OpenToWorkStatus = ({ isOpenToWork }: OpenToWorkStatusProps) => {
  const dotColor = isOpenToWork ? 'bg-emerald-400' : 'bg-amber-400';
  const glowColor = isOpenToWork ? 'bg-emerald-400/40' : 'bg-amber-400/40';
  const textColor = isOpenToWork ? 'text-emerald-400' : 'text-amber-400';

  const label = isOpenToWork ? 'Available for new adventures' : 'Currently on a mission at Connect Assistance';

  return (
    <div className={`inline-flex items-center gap-2 px-4 py-1.5 mb-5   transition-colors`}>
      <span className="relative flex h-2.5 w-2.5">
        <span className={`absolute inline-flex h-full w-full animate-ping rounded-full ${glowColor}`} />
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${dotColor}`} />
      </span>
      <span className={`text-sm font-medium tracking-wide ${textColor}`}>Work status:. {label} </span>
    </div>
  );
};

export default OpenToWorkStatus;
